import { useMutation } from "@apollo/client"
import { GAME_UPDATE } from "../queries/adminQueries"

export interface GameUpdateInput {
  id: number
  name: string
  description?: string
  isActive: number
  urlImage?: string
}

export const useGameUpdate = () => {
  const [updateGame, { loading, error }] = useMutation(GAME_UPDATE)

  const handleUpdateGame = async (input: GameUpdateInput) => {
    const { data } = await updateGame({
      variables: {
        GameEditInput: {
          id: input.id,
          name: input.name,
          description: input.description,
          isActive: input.isActive,
        },
      },
    })
    return data?.GameEdit
  }

  return {
    updateGame: handleUpdateGame,
    loading,
    error,
  }
}
